import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import PackagesHero from './components/PackagesHero';
import PackageCards from './components/PackageCards';
import PackageComparison from './components/PackageComparison';
import PackageFAQ from './components/PackageFAQ';
import CTASection from '../home/components/CTASection';
import { useSEO } from '../../utils/seo';

const PackagesPage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  useSEO({
    title: 'Paketler ve Fiyatlandırma - Sigorta360 | Dijital Pazarlama Paketleri',
    description: 'Sigorta acenteleri için özel hazırlanmış dijital pazarlama paketleri. Başlangıç, Profesyonel ve Premium paketlerimizi inceleyin. Her bütçeye uygun çözümler.',
    keywords: 'sigorta dijital paketler, sigorta pazarlama fiyat, sigorta sosyal medya paketi, sigorta reklam paketi, dijital ajans fiyatları',
    canonical: `${siteUrl}/paketler`,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'Product',
      name: 'Sigorta360 Dijital Pazarlama Paketleri',
      description: 'Sigorta acenteleri için özel dijital pazarlama paketleri',
      brand: {
        '@type': 'Brand',
        name: 'Sigorta360'
      },
      offers: {
        '@type': 'AggregateOffer',
        priceCurrency: 'TRY',
        lowPrice: '15000',
        highPrice: '45000',
        offerCount: '3'
      }
    }
  });

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <PackagesHero />
        <PackageCards />
        <PackageComparison />
        <PackageFAQ />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default PackagesPage;
